import React from 'react';

function AboutPage() {
  return (
    <div style={{ padding: '2rem', minHeight: '60vh' }}>
      <h1>關於我們</h1>
      <p>此頁面內容開發中...</p>
    </div>
  );
}

export default AboutPage;
